import { defineStore } from 'pinia'

export const useViewStore = defineStore('view', {
  state: () => ({
    actionView: 'planner',  // Default view
	username: '',
	countActiveUsers: 0,
	openProjects: [],
	allBookings: true,
	activeProjects: true,
	plannedProjects: false,
	printTimeStart: null,
	printTimeEnd: null,
	zoomVal: null,
	zoomStart: null,
	zoomEnd: null,
	zoomWidthPerDay: null,
	resourceFilters: {},
  }),
  actions: {
	isZoom() {
        return this.zoomWidthPerDay !== null;
	},
    setActionView(view) {
      this.actionView = view
    },
	setUsername(username) {
	  this.username = username
	},
	setCountActiveUsers(countActiveUsers) {
	  this.countActiveUsers = countActiveUsers
	},
    toggleProject(pid) {
      if (this.openProjects.includes(pid)) {
        this.openProjects = this.openProjects.filter(el => el !== pid);
      } else {
        this.openProjects.push(pid);
      }
	},
	isOpenProject(pid) {
		return this.openProjects.includes(pid);
	},
	setProjectFilter(all, active, planned) {
	  console.log("setProjectFilter all=" + all + " active=" + active + " planned=" + planned)
	  this.allBookings = all;
	  this.activeProjects = active;
	  this.plannedProjects = planned;
	},
	showAllBookings() {
	  return this.allBookings; 
	},
	showActiveProjects() {
	  return this.activeProjects;
	},
	showPlannedProjects() {
	  return this.plannedProjects;
	},
	getResourceFilter(pid) {
	  if (this.resourceFilters[pid] == null) {
		this.resourceFilters[pid] = {selection: 0, individual: []};
	  }
	  if (this.resourceFilters[pid].individual == null) {
		this.resourceFilters[pid].individual = [];
	  }
	  return this.resourceFilters[pid];
	},
	setResourceFilter(pid, selection, individual) {
	  if (this.resourceFilters[pid] == null) {
		this.resourceFilters[pid] = {}
	  }
	  this.resourceFilters[pid].selection  = selection;
	  this.resourceFilters[pid].individual = individual;
	},
	setPrintTimeStart(startdate) {
	  this.printTimeStart = startdate;
	},
	setPrintTimeEnd(enddate) {
	  this.printTimeEnd = enddate;
	},
	setZoomVal(zoomVal) {
	  this.zoomVal = zoomVal;
	},
	setZoomStart(zoomStart) {
	  this.zoomStart = zoomStart;
	},
	setZoomEnd(zoomEnd) {
	  this.zoomEnd = zoomEnd;
	},
	setZoomWidthPerDay(width) {
	  this.zoomWidthPerDay = width;
	}
  },
  persist: {
    pick: ['actionView', 'allBookings', 'activeProjects', 'plannedProjects', 'printTimeStart', 'printTimeEnd', 'zoomVal', 'zoomStart', 'zoomEnd', 'zoomWidthPerDay', 'resourceFilters'],
  },
})
